import React, { useState } from 'react'
import Select from 'react-select'

export default function UserGroupTerritorySelect({ userGroupTerritories, options }) {
  const formattedOptions = JSON.parse(options).map((o) => ({ value: o.id, label: o.name }))
  const defaultTerritoryIds = JSON.parse(userGroupTerritories).map((ugt) => ugt.territory_id)
  const defaultValue = formattedOptions.filter((o) => defaultTerritoryIds.includes(o.value))

  const [value, setValue] = useState(defaultValue);

  return (
    <div className='form-group'>
      <label>Territories</label>
      <div className='border p-4 rounded'>
        <Select
          isMulti
          options={formattedOptions}
          value={value} // Bind to external state
          onChange={setValue} // Update external state on change
        />
      </div>
      {
        value.map((v) => (
          <input key={v.value} name="user_group[territory_ids][]" value={v.value} />
        ))
      }
    </div>
  )
}
